/**
 * Global settings
 */
const now = Date.now(),
    /* Amount limits for prospects (ENV="DESKTOP") */
    public_amount_max = 5000,
    public_amount_min = 500,
    /* Default duration */
    default_duration = 12,
    /* Setup fees */
    setup_fees = 0,
    /* CTA */
    prospectURL = DEV ?
        /** Contact form doesn't work properly: it doesn't find the nearest agency (2023-07-31) **/
        // "https://www.axa.fr/contacter-agent/contacter-conseiller.html" :
        // "https://www.axa.fr/contacter-agent/contacter-conseiller.html",
        "https://agence.axa.fr/?pretPerso" :
        "https://agence.axa.fr/?pretPerso",
    messagerieURL = DEV ?
        "https://mon-ab.hml.bad.arkea.com/messagerie/ecriremessage" :
        "https://banque.axa.fr/messagerie/nouveau-message",
    devisURL = DEV ?
        // PP: "https://preview-pp.axa.fr/compte-bancaire/pret-personnel/devis-pret-perso.html"
        // R7: "https://preview-salt-recprjmkt.axa.fr/compte-bancaire/pret-personnel/devis-pret-perso.html"
        "https://preview-salt-recprjmkt.axa.fr/compte-bancaire/pret-personnel/devis-pret-perso.html" :
        "https://www.axa.fr/compte-bancaire/pret-personnel/devis-pret-perso.html",
    simuppURL = ENV === "DESKTOP" ?
        "https://www.axa.fr/compte-bancaire/pret-personnel/simulateur-credit-conso.html" :
        "https://www.axa.fr/compte-bancaire/application-mobile-webview/simulateur-pret-perso.html";
    /* URL parameters presets */
    let parameters = {};

/**
 * Legal mentions
 * Replaces the footer legal paragraphs (all but the title) with promo-specific ones.
 */
function renderLegalMentions(paragraphs) {
   if (!Array.isArray(paragraphs) || paragraphs.length === 0) {
      return;
   }
   const body = document.querySelector(".axb-legal-mentions__body");
   if (!body) {
      return;
   }
   const title = body.querySelector("p");
   if (!title) {
      return;
   }
   let current = title.nextElementSibling;
   while (current) {
      const next = current.nextElementSibling;
      if (current.tagName === "P") {
         current.remove();
      }
      current = next;
   }
   paragraphs.forEach(html => {
      const p = document.createElement("p");
      p.innerHTML = '<span class="text-legal text--xs">' + html + "</span>";
      body.appendChild(p);
   });
}

/**
 * Credit data
 */
var valid_discount_code = false,
   discount_code = null,
   discount_code_label = null,
   current_global_discount = null,
   current_actioncom_discount = null,
   additional_fields = null,
   offer_type = "classic",

   credit = null,
   current_global_discounts = null,
   current_actioncom_discounts = null,
   credit_rates = [],
   credit_amount_min = public_amount_min,
   credit_amount_max = public_amount_max,
   credit_durations = [],

   credit_amount = null,                     // amount
   credit_duration = null,                   // duration
   credit_nb_monthly = 0,                    // nb_mensualites

   credit_monthly_cost = 0,                  // mens_hors_ass
   insurance_credit_monthly_cost = null,     // mens_ac_ass

   insurance_monthly_cost = 0,               // ct_moy_mens_ass

   credit_last_monthly = 0,                   // dern_mensu_ajustee
   insurance_credit_last_monthly_cost = null, // dern_mensu_ajustee_ac_ass

   credit_total_cost = 0,                    // ct_tt_credit_hors_ass
   insurance_credit_total_cost = null,       // ct_tt_credit_ac_ass

   deb_rate = 0,                             // tx_deb_rev
   taeg = 0,                                 // taeg_rev
   taea = null,                              // taea

   credit_interest = 0,                      // (computed)
   insurance_interest = 0;                   // (computed)

/**
 * initCreditData
 * Initialize base credit data
 */
function initCreditData(args) {
   // console.log("credit_rates", credit_rates);

   credit_amount_min = args.amount_min;

   credit_amount_max = args.amount_max;

   credit_amount = isCreditAmountValid(credit_amount) ? credit_amount : null;
}

/**
 * resetCreditData
 * Reset base credit data
 */
function resetCreditData() {
   credit = null;
   /* Credit amount */
   credit_amount = null;
   /* Credit durations */
   credit_durations = [];
   credit_duration = null;

   computeData();
   renderUI();
}

/**
 * resetActionComDiscountData
 * Reset actioncomdiscount data
 */
function resetActionComDiscountData() {
   discount_code = null;
   current_actioncom_discount = null;

   computeData();
   renderUI();
}

/**
 * Credit preset
 */

/* API */
var apiURL = DEV_API ? "https://backoffice-simulateurs-dev.axabanque-dvd.com/api/revolving-credits" : "https://backoffice-simulateurs.axabanque-dvd.com/api/revolving-credits",
    offer_type_classic_url = apiURL + "?offer_type=classic",
    offer_type_special_url = apiURL + "?offer_type=special",
    offer_type_promo_url = apiURL + "?offer_type=promo";

var discounts_special_url = "/dam/axa/desktop/banque-credits/banque-simulateur-credit-conso/actioncomdiscounts_special.json";


/* Data get from server */
var rates = null,
    actioncomdiscounts_special = null;

/**
 * getRates
 */
function getRates(offerType = "classic") {
  var requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };
  
  fetch(apiURL + "?offer_type=" + offerType, requestOptions)
    .then(response => response.text())
    .then((result) => {
      let data = JSON.parse(result).data;
      rates = data.reduce(function(acc, it) {
        let key = parseInt(it.amount);
        if (!acc[key]) {
          acc[key] = {};
        }
        acc[key][it.duration] = it;
        return acc;
      }, {});

      let amounts = Object.keys(rates),
          amount_min = amounts[0],
          amount_max = amounts[amounts.length - 1];
      let durations = Object.keys(rates[amount_max]),
          duration_min = durations[0],
          duration_max = durations[durations.length - 1];
      initCreditData({
        "amount_max": parseInt(amount_max),
        "amount_min": parseInt(amount_min),
        "duration_max": parseInt(duration_max),
        "duration_min": parseInt(duration_min)
      });
      
      computeData();
      renderUI();
    })
    .catch(error => console.log('error', error));
}

/**
 * getDiscountsSpecial
 */
function getDiscountsSpecial(campaignLabel, offerType) {
  let requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };

  fetch(discounts_special_url, requestOptions)
    .then(response => response.text())
    .then((result) => {
      actioncomdiscounts_special = JSON.parse(result);
      current_actioncom_discount = actioncomdiscounts_special[campaignLabel];

      if (current_actioncom_discount) {
        current_actioncom_discount.isAppliable =
          (ENV === "APP-MOBILE" && current_actioncom_discount.mobile) ||
          (ENV === "DESKTOP" && current_actioncom_discount.desktop);
        // discount.isEligible = (discount.durations.length > 0
        //    && discount.durations.indexOf(creditDuration.toString()) !== -1
        //    && creditAmount >= discount.amount_min
        //    && creditAmount <= discount.amount_max);
        current_actioncom_discount.isEligible = true;
        // discount.isValid = (discount.start_date && now >= discount.start_date)
        //    && (discount.end_date && now <= discount.end_date);
        current_actioncom_discount.isValid = true;
        // discount.actioncomdiscount_code ? "" : discount.description;
        getRates(offerType);
      } else {
        getRates();
      }
    })
    .catch(error => console.log('error', error));
}

/**
 * presetFormByUrl
 */
function presetFormByUrl() {
  /* Parameters (get) */
  let UrlParser = new GetURLParams(window.location.search);
      parameters = UrlParser.urlParams;

  if (parameters["promo"]) {
    if (
      parameters["promo"].indexOf("special") !== -1 ||
      parameters["promo"].indexOf("classic") !== -1
    ) {
      let campaignInfos = parameters["promo"].split("_");
      offer_type = campaignInfos[campaignInfos.length - 1]; // special|classic
      discount_code = campaignInfos[0].toUpperCase();
    } else {
      offer_type = "promo";
      discount_code = parameters["promo"].toUpperCase();
    }

    getDiscountsSpecial(parameters["promo"] + "_CR", offer_type);
  } else {
    getRates();
  }

  if (parameters["AGA"] || parameters["A2P"]) {
    // Hide intro
    $simuIntro.style.display = "none";

    // Hide credit type field and credit infos block
    $creditTypeField.style.display = "none";
    $creditInfos.style.display = "none";

    // Hide additionals fields
    document.querySelector('.c-additional-fields').style.display = "none";

    // Hide warning block
    document.querySelector('.c-section.c-warning').style.display = "none";

    // Hide CTA
    document.querySelector(".c-section.c-cta").style.display = "none";
  }

  console.log("ENV", ENV);
}

/**
 * renderCreditAmount
 * Display credit amount field
 */
function renderCreditAmount() {
  $creditAmountField.querySelector(".c-label__placeholder").innerHTML = "Entre "
    + stringifyPrice(credit_amount_min).replace(" ", "&nbsp;") + " et "
    + stringifyPrice(credit_amount_max).replace(" ", "&nbsp;") + "&nbsp;€";

  $creditAmount.setAttribute(
    "placeholder",
    "Entre " + stringifyPrice(credit_amount_min) + " et " + stringifyPrice(credit_amount_max) + " €"
  );

  if (isCreditAmountRangeValid(credit_amount) && !isCreditAmountMultipleOf500(credit_amount)) {
    $creditAmountField.querySelector(".c-field__error").innerHTML =
      "Le montant doit être un multiple de 500. Exemples&nbsp;: 500, 1000, 1500, 2000, etc.";
  } else {
    $creditAmountField.querySelector(".c-field__error").innerHTML =
      "Veuillez saisir un montant compris entre "
      + stringifyPrice(credit_amount_min).replace(" ", "&nbsp;") + " et "
      + stringifyPrice(credit_amount_max).replace(" ", "&nbsp;") + "&nbsp;€.";
  }

  $creditAmount.value = stringifyPrice(credit_amount);

  document.querySelector("label[for=credit-type-cr] .c-radio-button__highlighted-label").innerHTML = "De "
    + stringifyPrice(credit_amount_min).replace(" ", "&nbsp;") + " à "
    + stringifyPrice(credit_amount_max).replace(" ", "&nbsp;") + "&nbsp;€";

  if (credit_amount) {
    if (isCreditAmountValid(credit_amount)) {
      $creditAmount.classList.add("valid");
      $creditAmount.classList.remove("error");
    } else {
      $creditAmount.classList.add("error");
      $creditAmount.classList.remove("valid");
    }
  } else {
    $creditAmount.classList.remove("valid");
    $creditAmount.classList.remove("error");
  }
}

/**
 * setCreditAmount
 */
function setCreditAmount(value) {
   credit_amount = numerizePrice(value);
   // console.log("credit_amount", credit_amount);
   computeData();
   renderUI();
}

function isCreditAmountValid(value) {
  if (!value) {
    return false;
  }

  if (parseInt(value) % 500 !== 0) {
    return false;
  }

  return parseInt(value) >= credit_amount_min && parseInt(value) <= credit_amount_max;
}

function isCreditAmountRangeValid(value) {
  if (!value) {
    return false;
  }

  return parseInt(value) >= credit_amount_min && parseInt(value) <= credit_amount_max;
}

function isCreditAmountMultipleOf500(value) {
  if (!value) {
    return false;
  }

  return parseInt(value) % 500 === 0;
}
/**
 * renderCreditDuration
 * Display credit duration field
 */
function renderCreditDuration() {
  if (isCreditAmountValid(credit_amount)) {
    if (credit_durations && credit_durations.length > 1) {
      $creditDurationField.classList.remove("hidden");
    }
    $creditTypeField.classList.remove("hidden");
    if (current_actioncom_discount && current_actioncom_discount.avantagesCR) {
      $creditInfos.classList.remove("hidden");
    }
  } else {
    $creditDurationField.classList.add("hidden");
    $creditTypeField.classList.add("hidden");
    $creditInfos.classList.add("hidden");
  }

  $creditDuration.innerHTML = "";

  // console.log("credit_durations", credit_durations);
  // console.log("credit_rates", credit_rates);

  if (credit_rates) {
    Object.keys(credit_rates).forEach(nb_months => {
      let nb_years = nb_months >= 12 ? nb_months / 12 : null;

      $creditDuration.innerHTML +=
        "<div class='c-radio-button c-radio-button--block'>"
        +  "<input id='credit-duration-" + nb_months + "' name='credit-duration' type='radio' value='" + nb_months + "'" + (nb_months == credit_duration ? "checked" : "") + " onchange='setCreditDuration(this.value);' >"
        +   "<label for='credit-duration-" + nb_months + "'>"
        +      "<span class='c-radio-button__label'>" + (nb_years ? (nb_years > 1 ? nb_years + " ans" : nb_years + " an") : (nb_months + " mois")) + "</span>"
        +      "<span class='c-radio-button__highlighted-label'>" + stringifyPrice(credit_rates[nb_months].mens_hors_ass.toFixed(2)) + " € / mois</span>"
        +   "</label>"
        + "</div>"
    });

    // Add class for CSS styles
    if (Object.keys(credit_rates).length > 0 && Object.keys(credit_rates).length < 4) {
      $creditDuration.setAttribute('class', 'c-fieldset__wrapper only-' + Object.keys(credit_rates).length);
    } else {
      $creditDuration.setAttribute('class', 'c-fieldset__wrapper');
    }
    
  }
}

/**
 * setCreditDuration
 */
function setCreditDuration(value = null) {
  if (value) {
    credit_duration = parseInt(value);
  } else {
    credit_duration = credit_durations && credit_durations.length > 0 ? credit_durations[0] : default_duration;
  }
  // console.log("credit_duration", credit_duration);
  computeData(true);
  renderUI();
}

/**
 * isCreditDurationValid
 */
function isCreditDurationValid(value) {
  if (!value) {
    return false;
  }

  return credit_durations.indexOf(value) !== -1;
}

/**
 * renderDiscountIntro
 * Promo "introduction" rule: non-empty string replaces the intro,
 * empty/whitespace-only string hides it, null/absent keeps the default intro.
 * @param {*} intro
 */
function renderDiscountIntro(intro) {
   if (typeof intro !== "string" || !$simuIntro) {
      return;
   }
   if (intro.trim() === "") {
      $simuIntro.classList.add("hidden");
   } else {
      $simuIntro.innerHTML = intro;
   }
}

/**
 * renderDiscount
 * Display discount infos (header, additional fields, legal mentions, etc.)
 */
function renderDiscount() {
   let className = ($discountDescription.className).replace("hidden", "").trim();

   if (current_actioncom_discount) {
      // Layout & fields
      if (current_actioncom_discount.isAppliable && current_actioncom_discount.isValid) {
         $simuCR.setAttribute("class", current_actioncom_discount.theme);
         if (!parameters["AGA"] && !parameters["A2P"]) {
            setAdditionalFields(current_actioncom_discount.fields);
            renderAdditionalFields();
         }
      }
      // Header + intro
      if (current_actioncom_discount.isValid && current_actioncom_discount.isAppliable) {
         $discountLabel.innerHTML = current_actioncom_discount.label ?
            current_actioncom_discount.label : "";
         $discountCatchphrase.innerHTML = current_actioncom_discount.catchphrase ?
            current_actioncom_discount.catchphrase : "";
         renderDiscountIntro(current_actioncom_discount.introduction);
         $durationTooltip.classList.add("hidden");
      }
      // Radio button credit type
      document.querySelector("label[for=credit-type-cr] .c-radio-button__sublabel").classList.remove("hidden");
      document.querySelector("label[for=credit-type-cr] .c-radio-button__sublabel").innerHTML = current_actioncom_discount.labelShort;
      // Description
      // Optional per-promo flag: hide the "En cours : ..." line (stays hidden, nothing injected)
      const hideCurrentOffer = current_actioncom_discount.hideCurrentOfferInMentions === true &&
         current_actioncom_discount.isAppliable && current_actioncom_discount.isValid;
      if (!hideCurrentOffer) {
         $discountDescription.setAttribute("class", className);
         if (!current_actioncom_discount.isAppliable) {
            $discountDescription.innerHTML =
               "<p>Ce code promo n'est pas applicable dans cet environnement.</p>";
         } else if (current_actioncom_discount.isValid) {
            $discountDescription.innerHTML =
               "<p><span class='semibold'>En cours&nbsp;:</span> " + current_actioncom_discount.labelShort + "</p>";
         } else {
            $discountDescription.innerHTML =
               "<p>Ce code promotionnel n'est plus valide.</p>";
         }
      }
      // CTA catchphrase
      if (current_actioncom_discount.isAppliable && current_actioncom_discount.isValid && current_actioncom_discount.cta_catchphrase) {
         $ctaCatchphrase.innerHTML = current_actioncom_discount.cta_catchphrase;
      }
      // Avantages CR
      if (current_actioncom_discount.isAppliable && current_actioncom_discount.isValid && current_actioncom_discount.avantagesCR) {
         $creditInfos.querySelector(".c-tip").innerHTML = current_actioncom_discount.avantagesCR.title + current_actioncom_discount.avantagesCR.body;
      }
      // Mentions
      if (current_actioncom_discount.isValid && current_actioncom_discount.isAppliable) {
         $discountMentions.innerHTML = current_actioncom_discount.mentions;
         $discountMentions.setAttribute("class", $discountMentions.className.replace("hidden", "").trim());
         renderLegalMentions(current_actioncom_discount.legalMentions);
      }

      /* hide global discount mentions */
      if (current_actioncom_discount.isValid && current_actioncom_discount.isAppliable && current_actioncom_discount.mentions) {
         $discountMentionsGlobal.setAttribute("class", $discountMentionsGlobal.className + " hidden");
      }
   } else {
      $discountDescription.innerHTML = "<p><strong>Il n'existe pas de taux promotionnel lié à ce code promo.</strong></p>";
   }

   if (!parameters["AGA"] && !parameters["A2P"]) {
      // if (discount_code === "LPCCR2023") {
      //    // Hide warning section
      //    const warningSection = document.querySelector('.c-section.c-warning');
      //    warningSection.setAttribute(
      //       "class",
      //       warningSection.getAttribute("class") + " hidden"
      //    );

      //    // Show CTA section
      //    const ctaSection = document.querySelector('.c-section.c-cta');
      //    ctaSection.setAttribute(
      //       "class",
      //       "c-section c-cta"
      //    );

      //    // Hide desktop CTA
      //    if ($desktopCTAStepper) {
      //       $desktopCTAStepper.setAttribute('class', 'c-cta--desktop hidden');
      //    }
      //    // Show single CTA
      //    if ($singleCTA) {
      //       $singleCTA.setAttribute('class', 'c-button business arrow-right large');
      //    }
      // }

      if (discount_code === "MMCCR2023") {
         // Show CTA section
         const ctaSection = document.querySelector('.c-section.c-cta');
         ctaSection.setAttribute(
            "class",
            "c-section c-cta"
         );

         // Hide desktop CTA
         if ($desktopCTAStepper) {
            $desktopCTAStepper.setAttribute('class', 'c-cta--desktop hidden');
         }
         // Show single CTA
         if ($singleCTA) {
            $singleCTA.setAttribute('class', 'c-button business arrow-right large');
         }
      }

      if (
         parameters["utm_content"] &&
         (
            parameters["utm_content"].indexOf("assu") !== -1 ||
            parameters["utm_content"].indexOf("inter") !== -1 ||
            parameters["utm_content"].indexOf("direct") !== -1 ||
            parameters["utm_content"].indexOf("EC") !== -1
         )
      ) {
         // Hide desktop CTA
         if ($desktopCTAStepper) {
            $desktopCTAStepper.setAttribute('class', 'c-cta--desktop hidden');
         }
         // Show single CTA
         if ($singleCTA) {
            $singleCTA.setAttribute('class', 'c-button business arrow-right large');
         }
      }

   }
}

/**
 * renderAdditionalFields
 * Display additional fields (in case of special actioncom discount)
 */
function renderAdditionalFields() {
   if (!additional_fields || additional_fields.length <= 0) {
      document.querySelector('.c-additional-fields').classList.add("hidden");
      return;
   }

   if (additional_fields.length === 1 && additional_fields.indexOf('insurance') !== -1) {
      document.querySelector('.c-additional-fields').classList.add("hidden");
   } else {
      document.querySelector('.c-additional-fields').classList.remove("hidden");
   }
   
   for (let i = 0; i < additional_fields.length; ++i) {
      if (!additional_fields[i]) {
        continue;
      }

      let field = document.getElementById("additional-field--" + additional_fields[i]);
      let className = (field.className).replace("hidden", "").trim();
      field.setAttribute("class", className);
   }
}

/**
 * hideAdditionalFields
 * Hide additional fields (in case of special actioncom discount)
 */
function hideAdditionalFields() {
   document.querySelector('.c-additional-fields').classList.add("hidden");

   let additionalFields = [
      "incomes",
      "charges",
      "insurance"
   ];

   for (let i = 0; i < additionalFields.length; ++i) {
      if (additional_fields && additionalFields[i].indexOf(additional_fields) !== -1) {
         continue;
      }

      let field = document.getElementById("additional-field--" + additionalFields[i]);
      field.classList.add("hidden");
   }
}

/**
 * setAdditionalFields
 */
function setAdditionalFields(fields = []) {
   additional_fields = fields;
   // console.log("additional_fields", additional_fields);
}

/**
 * isAdditionalFieldsValid
 */
function isAdditionalFieldsValid(fields = []) {
   if (!fields) {
      return true;
   }

   let isValid = true;

   for (let i = 0; i < fields.length; ++i) {
      if (!fields[i]) {
        continue;
      }

      let field = fields[i],
          value = document.getElementById(field).value;

      if (field == "incomes" || field == "charges") {
         if (!value) {
            return false;
         }

         isValid = isValid && numerizePrice(value) >= 0;
      }

      if (field == "insurance") {
         continue;
      }
   }

   return isValid;
}

/**
 * isIncomesValid
 */
function isIncomesValid(value) {
   if (!value) {
     return false;
   }

   let numValue = numerizePrice(value);
   return typeof numValue === "number" && !isNaN(numValue);
}

/**
 * isChargesValid
 */
function isChargesValid(value) {
   if (!value) {
     return false;
   }

   let numValue = numerizePrice(value);
   return typeof numValue === "number" && !isNaN(numValue);
}

// AnimateCounter(element, delay, start, className)
// //=include ../../../base/js/components/scrollEvents.js

/**
 * renderAdditionalSections
 * Display additional sections (in case of special actioncom discount)
 */
function renderAdditionalSections() {
   if (!current_actioncom_discount) {
      return;
   }

   if (!current_actioncom_discount.additionalSections) {
      return;
   }

   $(current_actioncom_discount.additionalSections).insertBefore("#legals");
   initAnimations();
}

/**
 * initAnimations
 */
function initAnimations() {
   const count_01 = document.getElementById("count_01");
   const count_02 = document.getElementById("count_02");
   const count_03 = document.getElementById("count_03");
   const count_04 = document.getElementById("count_04");

   if (count_01) {
      new AnimateCounter(count_01, 0, 550, "c-count");
   }
   if (count_02) {
      new AnimateCounter(count_02, 1700, 550, "c-count");
   }
   if (count_03) {
      new AnimateCounter(count_03, 3100, 550, "c-count");
   }
   if (count_04) {
      new AnimateCounter(count_04, 4300, 550, "c-count");
   }
}

/**
 * renderResult
 * Display result
 */
function renderResult() {
  let className = $result.className.replace("hidden", "").trim();
  if (
   isCreditAmountValid(credit_amount)
  ) {
     $result.setAttribute("class", className);
  } else {
     $result.setAttribute("class", className + " hidden");
  }

   let creditDurationInYears = credit_duration >= 12 ? credit_duration / 12 : null;
   
   // Hide insurance data if insurance credit monthy cost is null
   if (insurance_credit_monthly_cost) {
      document.querySelectorAll(".insurance-data").forEach(elt => { elt.classList.remove("hidden"); });
      document.querySelectorAll(".insurance-monthly-cost").forEach(elt => { elt.innerHTML = stringifyPrice(insurance_monthly_cost).replace(" ", "&nbsp;"); });
      document.querySelectorAll(".taea").forEach(elt => { elt.innerHTML = (parseFloat(taea).toFixed(2).toString()).replace(".", ","); });
      document.querySelectorAll(".insurance-credit-total-cost").forEach(elt => { elt.innerHTML = stringifyPrice((insurance_monthly_cost * credit_duration).toFixed(2)).replace(" ", "&nbsp;"); });
      $resultDetails.querySelectorAll(".insurance-credit-monthly-cost").forEach(elt => { elt.innerHTML =  stringifyPrice(insurance_credit_monthly_cost.toFixed(2)).replace(" ", "&nbsp;"); } );
      $resultDetails.querySelector(".insurance-total-cost").innerHTML = stringifyPrice((insurance_monthly_cost * credit_duration).toFixed(2)).replace(" ", "&nbsp;");
      $resultDetails.querySelector(".total-with-insurance").innerHTML = stringifyPrice(insurance_credit_total_cost.toFixed(2)).replace(" ", "&nbsp;");
   } else {
      document.querySelectorAll(".insurance-data").forEach(elt => { elt.classList.add("hidden"); });
      document.querySelectorAll(".insurance-monthly-cost").forEach(elt => { elt.innerHTML = "-"; });
      document.querySelectorAll(".taea").forEach(elt => { elt.innerHTML = "-"; });
      document.querySelectorAll(".insurance-credit-total-cost").forEach(elt => { elt.innerHTML = "-"; });
      $resultDetails.querySelectorAll(".insurance-credit-monthly-cost").forEach(elt => { elt.innerHTML =  "-"; } );
      $resultDetails.querySelector(".insurance-credit-last-monthly").innerHTML = "-";
      $resultDetails.querySelector(".insurance-total-cost").innerHTML = "-";
      $resultDetails.querySelector(".total-with-insurance").innerHTML = "-";
   }

   // Hide last monthly if null
   if (!credit_last_monthly) {
      document.querySelector(".last-monthly").classList.add("hidden");
   } else {
      document.querySelector(".last-monthly").classList.remove("hidden");
   }
   if (!insurance_credit_last_monthly_cost) {
      document.querySelector(".last-monthly-insurance").classList.add("hidden");
   } else {
      $resultDetails.querySelector(".insurance-credit-last-monthly").innerHTML = stringifyPrice(insurance_credit_last_monthly_cost.toFixed(2)).replace(" ", "&nbsp;");
      document.querySelector(".last-monthly-insurance").classList.remove("hidden");
   }

   $resultDetails.querySelector(".credit-amount").innerHTML = stringifyPrice(credit_amount).replace(" ", "&nbsp;");
   $resultDetails.querySelectorAll(".credit-duration").forEach(elt => { elt.innerHTML = creditDurationInYears ? (creditDurationInYears > 1 ? creditDurationInYears + " ans" : creditDurationInYears + " an") : (credit_duration + " mois"); } );

   $resultDetails.querySelector(".credit-nb-monthly").innerHTML = stringifyPrice(credit_nb_monthly);
   
   $resultDetails.querySelector(".deb-rate").innerHTML = (deb_rate.toFixed(2).toString()).replace(".", ",");
   $resultDetails.querySelector(".taeg").innerHTML = (parseFloat(taeg).toFixed(2).toString()).replace(".", ",");
   
   $resultDetails.querySelector(".setup-fees").innerHTML = stringifyPrice(setup_fees.toFixed(2));
   $resultDetails.querySelector(".credit-total-cost").innerHTML = stringifyPrice(credit_total_cost).replace(" ", "&nbsp;");
   
   $resultDetails.querySelector(".total").innerHTML = stringifyPrice(credit_total_cost.toFixed(2)).replace(" ", "&nbsp;");
   
   $resultDetails.querySelectorAll(".credit-monthly-cost").forEach(elt => { elt.innerHTML =  stringifyPrice(credit_monthly_cost.toFixed(2)).replace(" ", "&nbsp;"); } );

   $resultDetails.querySelector(".credit-last-monthly").innerHTML = stringifyPrice(credit_last_monthly).replace(" ", "&nbsp;");
}

/**
 * computeData
 * Compute and give value to credit data
 */
function computeData(updateCreditDuration) {
   if (!credit_amount || !isCreditAmountValid(credit_amount)) {
      return;
   }

   credit_durations = [];
   Object.keys(rates[credit_amount]).forEach(elt => { credit_durations.push(parseInt(elt)); });

   // console.log("credit_duration", credit_duration);
   if (!updateCreditDuration) {
      setCreditDuration();
   }

   credit_rates = rates[credit_amount];

   let credit_data = rates[credit_amount][credit_duration];

   taeg = credit_data.taeg_rev;
   deb_rate = credit_data.tx_deb_rev;

   credit_monthly_cost = credit_data.mens_hors_ass;
   insurance_credit_monthly_cost = credit_data.mens_ac_ass;
   credit_interest = (credit_monthly_cost * credit_duration) - credit_amount;
   
   credit_nb_monthly = credit_data.nb_mensualites;

   credit_total_cost = credit_data.ct_tt_credit_hors_ass;
   insurance_credit_total_cost = credit_data.ct_tt_credit_ac_ass;

   credit_last_monthly = credit_data.dern_mensu_ajustee;
   insurance_credit_last_monthly_cost = credit_data.dern_mensu_ajustee_ac_ass;
   
   insurance_monthly_cost = credit_data.ct_moy_mens_ass;
   insurance_interest = insurance_monthly_cost * credit_duration;

   taea = credit_data.taea;
}
/**
 * Utils
 */

var $simuCR = document.getElementById("simu-cr"),
    $durationTooltip = document.getElementById("duration-tooltip"),
    $ctaCatchphrase = document.getElementById("cta-catchphrase"),
    $discountLabel = document.getElementById("discount-label"),
    $simuIntro = document.getElementById("simu-intro"),
    $discountCatchphrase = document.getElementById("discount-catchphrase"),
    $discountDescription = document.getElementById("discount-description"),
    $discountMentionsGlobal = document.getElementById("discount-mentions-global"),
    $discountMentions = document.getElementById("discount-mentions");
var $creditAmountField = document.getElementById("field--credit-amount"),
    $creditTypeField = document.getElementById("field--credit-type"),
    $creditInfos = document.getElementById("infos--credit"),
    $creditDurationField = document.getElementById("field--credit-duration");
var $creditAmount = document.getElementById("credit-amount"),
    $creditDuration = document.getElementById("credit-duration"),
    $creditDurationRadio = document.querySelectorAll("input[name='credit-duration']"),
    $result = document.getElementById("result"),
    $resultDetails = $result.querySelector(".c-details"),
    $resultInsurance = $result.querySelector(".c-insurance");
var $desktopCTAStepper = document.getElementById("cta-desktop-stepper"),
    $desktopCTA = document.getElementById("cta-desktop"),
    $desktopProspectCTA = document.getElementById("desktop-prospect-cta"),
    $desktopCustomerCTA = document.getElementById("desktop-customer-cta"),
    $mobileCTAStepper = document.getElementById("cta-mobile-stepper"),
    $customerMobileCTA = document.getElementById("mobile-customer-cta"),
    $singleCTA = document.getElementById("single-cta"),
    $resetButton = document.getElementById("reset-button");
// Additional fields
var $incomes = document.getElementById("incomes"),
    $charges = document.getElementById("charges"),
    $insurance = document.getElementById("insurance");

/**
 * renderUI
 */
function renderUI() {
   renderCreditAmount();
   renderCreditDuration();
   renderDiscount();
   renderResult();
}

/**
 * stringifyPrice
 * Return a number as a string, with space between hundreds
 */
function stringifyPrice(number, prefix, thousand_separator, decimal_separator) {
  if (!number) {
    return "";
  }

  number = number.toString();

  var thousand_separator = thousand_separator || " ",
      decimal_separator = decimal_separator || ".",
      regex		= new RegExp("[^" + decimal_separator + "\\d]", "g"),
      number_string = number.replace(regex, '').toString(),
      split = number_string.split(decimal_separator),
      rest = split[0].length % 3,
      result = split[0].substr(0, rest),
      thousands = split[0].substr(rest).match(/\d{3}/g);

  if (thousands) {
    let separator = rest ? thousand_separator : "";
    result += separator + thousands.join(thousand_separator);
  }

	result = split[1] != undefined ? result + "," + split[1] : result;
	return prefix == undefined ? result : (result ? prefix + result : "");
}

/**
 * numerizePrice
 * Return a formatted price string as a number
 */
function numerizePrice(val) {
  let v = val.toString().replace(/\s/g, "");
  return parseInt(v);
}

/**
 * GetURLParams
 */
class GetURLParams {
  constructor (urlSearch) {
    this.urlSearch = urlSearch
    this.urlParams = this.parseUrlSearch(this.urlSearch)
  }

  parseUrlSearch (query) {
    if (!query) {
      return {};
    }

    let vars = query.split('&');
    let query_string = {};

    for (var i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      pair[0] = pair[0].replace('?', '');
      // If first entry with this name
      if (typeof query_string[pair[0]] === 'undefined') {
        query_string[pair[0]] = decodeURIComponent(pair[1]);
        // If second entry with this name
      } else if (typeof query_string[pair[0]] === 'string') {
        let arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
        query_string[pair[0]] = arr;
        // If third or later entry with this name
      } else {
        query_string[pair[0]].push(decodeURIComponent(pair[1]));
      }
    }

    return query_string;
  }
}

/**
 * findObjectKey
 */
function findObjectKey(obj, value) {
  let key = null;

  for (let prop in obj) {
  	if (obj.hasOwnProperty(prop)) {
  		if (obj[prop] === value) {
        key = prop;
  		}
  	}
  }

  return key;
}

/**
 * getObjectValues
 */
function getObjectValues(obj) {
  if (!obj) {
    return [];
  }

  let values = [];
  for (let key in obj) {
    values.push(obj[key]);
  }

  return values;
}

(function () {
  // Get data
   presetFormByUrl();

  // Handle credit amount
  $creditAmount.onkeyup = function (e) {
     e.preventDefault();
     e.stopPropagation();
     setCreditAmount(this.value);
  };

  // Handle additional fields
  $incomes.onkeyup = function (e) {
     $incomes.value = stringifyPrice(this.value);

     let incomesClassName = ($incomes.className).replace("valid", "").replace("error", "").trim();
     $incomes.setAttribute("class", incomesClassName);
     $incomes.setAttribute("class", incomesClassName + " " + (isIncomesValid(this.value) ? "valid" : "error"));

     renderUI();
  }

  $charges.onkeyup = function (e) {
     $charges.value = stringifyPrice(this.value);

     let chargesClassName = ($charges.className).replace("valid", "").replace("error", "").trim();
     $charges.setAttribute("class", chargesClassName);
     $charges.setAttribute("class", chargesClassName + " " + (isChargesValid(this.value) ? "valid" : "error"));

     renderUI();
  }

  $insurance.onchange = function (e) {
   $resultDetails.querySelector("#credit-monthly-cost .credit-monthly-cost").classList.remove("hidden");
   $resultDetails.querySelector("#credit-monthly-cost .insurance-credit-monthly-cost").classList.add("hidden");

   $resultDetails.querySelector("#total th").classList.remove("semibold", "axablue");
   $resultDetails.querySelector("#total td").classList.remove("semibold", "axablue");

   $resultDetails.querySelector("#total-with-insurance th").classList.remove("semibold", "axablue");
   $resultDetails.querySelector("#total-with-insurance td").classList.remove("semibold", "axablue");

   if (this.checked) {
      $resultDetails.querySelector("#credit-monthly-cost .credit-monthly-cost").classList.add("hidden");
      $resultDetails.querySelector("#credit-monthly-cost .insurance-credit-monthly-cost").classList.remove("hidden");
      $resultDetails.querySelector("#total-with-insurance th").classList.add("semibold", "axablue");
      $resultDetails.querySelector("#total-with-insurance td").classList.add("semibold", "axablue");
   } else {
      $resultDetails.querySelector("#credit-monthly-cost .credit-monthly-cost").classList.remove("hidden");
      $resultDetails.querySelector("#credit-monthly-cost .insurance-credit-monthly-cost").classList.add("hidden");
      $resultDetails.querySelector("#total th").classList.add("semibold", "axablue");
      $resultDetails.querySelector("#total td").classList.add("semibold", "axablue");
   }
  }

  $resetButton.onclick = function (e) {
   resetCreditData();
  }

  // Handle CTA
  let $desktopCTAstepper = document.getElementById("cta-desktop-stepper");
  $desktopCTA.onclick = function (e) {
     e.preventDefault();
     e.stopPropagation();

     if (!document.querySelector('.c-additional-fields').classList.contains("hidden")) {
      if (!isIncomesValid($incomes.value) || !isChargesValid($charges.value)) {
         $incomes.dispatchEvent(new KeyboardEvent('keyup'));
         $charges.dispatchEvent(new KeyboardEvent('keyup'));
         return;
      }
     }

     $desktopCTAstepper.setAttribute("class", $desktopCTAstepper.className + " step1");
  }
  /* Prospect CTA: redirect to souscription form */
  $desktopProspectCTA.onclick = function (e) {
     e.preventDefault();
     e.stopPropagation();

     window.location.href = prospectURL;
  };

   /* Credit Form URL: redirect to "devis générique" form */
   let devisCTA = function (e, redirectURL = null, additionalParameters = null) {
      if(!isAdditionalFieldsValid(additional_fields)) {
         for (let i = 0; i < additional_fields.length; ++i) {
            let input = document.getElementById(additional_fields[i]);
            input.dispatchEvent(new KeyboardEvent('keyup'));
         }

         return;
      }

     e.preventDefault();
     e.stopPropagation();

     console.log("devis générique");

     if (!redirectURL) {
        redirectURL = devisURL;
     }

     let discountCode = "";
     if (current_actioncom_discount && current_actioncom_discount.isValid && current_actioncom_discount.isEligible) {
        discountCode = discount_code;
     }

     window.location.href = redirectURL
        + "?projet=" + encodeURIComponent("Crédit Renouvelable")
        + "&montantPret=" + encodeURIComponent($result.querySelector(".credit-amount").textContent)
        + "&duree=" + encodeURIComponent($result.querySelector(".credit-duration").textContent)
        + "&mensualite_hors_assurance=" + encodeURIComponent($result.querySelector(".credit-monthly-cost").textContent)
        + "&derniere_mensualite_hors_assurance=" + encodeURIComponent($result.querySelector(".credit-last-monthly").textContent)
        + "&taeg=" + encodeURIComponent($result.querySelector(".taeg").textContent)
        + "&tea=" + encodeURIComponent($resultInsurance.querySelector(".taea").textContent)
        + "&taux_debiteur=" + encodeURIComponent($result.querySelector(".deb-rate").textContent)
        + "&montant_du=" + encodeURIComponent($result.querySelector(".total").textContent)
        + "&cout_mensuel_assurance=" + encodeURIComponent($result.querySelector(".insurance-monthly-cost").textContent)
        + "&mensualite_avec_assurance=" + encodeURIComponent($result.querySelector(".insurance-credit-monthly-cost").textContent)
        + "&" + encodeURIComponent($result.querySelector(".credit-nb-monthly").textContent + "_mensualités_de") + "=" + encodeURIComponent($result.querySelector(".credit-monthly-cost").textContent)
        + "&derniere_mensualite_ajustee_avec_assurance=" + encodeURIComponent($result.querySelector(".insurance-credit-last-monthly").textContent)
        + "&cout_total_credit_hors_assurance=" + encodeURIComponent($result.querySelector(".credit-total-cost").textContent)
        + "&cout_total_assurance=" + encodeURIComponent($result.querySelector(".insurance-total-cost").textContent)
        + "&frais_dossier=" + encodeURIComponent($result.querySelector(".setup-fees").textContent)
        + "&code_promo=" + encodeURIComponent(discountCode)
        + (additionalParameters && additionalParameters.length > 0 ? additionalParameters : "")
        + (redirectURL === devisURL ? "&#1" : ""); // to force "devis générique" form to step 2
  };

   /* Messagerie CTA: redirect to "Espace Client messagerie > Crédit conso" */
  let messagerieCTA = function(e, redirectURL = null) {
   if(!isAdditionalFieldsValid(additional_fields)) {
      for (let i = 0; i < additional_fields.length; ++i) {
         let input = document.getElementById(additional_fields[i]);
         input.dispatchEvent(new KeyboardEvent('keyup'));
      }

      return;
   }

   e.preventDefault();
   e.stopPropagation();

   console.log("messagerie sécurisée");

   if (!redirectURL) {
      redirectURL = messagerieURL;
   }
   let url = redirectURL;

   // This code is only temporary disabled while we are waiting from a fix on Arkea side
   /*let url = redirectURL
         + "?simulateur=creditrenouvelable";

      url += "&" + encodeURIComponent("Simulation") + "=" + encodeURIComponent("Crédit Renouvelable")
         + "&" + encodeURIComponent("Montant_prêt") + "=" + encodeURIComponent($result.querySelector(".credit-amount").textContent + " €")
         + "&" + encodeURIComponent("Durée") + "=" + encodeURIComponent($result.querySelector(".credit-duration").textContent)
         + "&" + encodeURIComponent("Mensualité_hors_assurance") + "=" + encodeURIComponent($result.querySelector(".credit-monthly-cost").textContent + " €")
         + "&" + encodeURIComponent("Dernière_mensualité_ajustée_hors_assurance") + "=" + encodeURIComponent($result.querySelector(".credit-last-monthly").textContent + " €")
         + "&" + encodeURIComponent("TAEG") + "=" + encodeURIComponent($result.querySelector(".taeg").textContent + " %")
         + "&" + encodeURIComponent("TAEA") + "=" + encodeURIComponent($resultInsurance.querySelector(".taea").textContent + " %")
         + "&" + encodeURIComponent("Taux_débiteur") + "=" + encodeURIComponent($result.querySelector(".deb-rate").textContent + " %")
         + "&" + encodeURIComponent("Montant_dû") + "=" + encodeURIComponent($result.querySelector(".total").textContent + " €")
         + "&" + encodeURIComponent("Coût_mensuel_assurance") + "=" + encodeURIComponent($resultInsurance.querySelector(".insurance-monthly-cost").textContent + " €")
         + "&" + encodeURIComponent("Mensualité_avec_assurance") + "=" + encodeURIComponent($result.querySelector(".insurance-credit-monthly-cost").textContent + " €")
         + "&" + encodeURIComponent($result.querySelector(".credit-nb-monthly").textContent + "_mensualités_de") + "=" + encodeURIComponent($result.querySelector(".credit-monthly-cost").textContent + " €")
         + "&" + encodeURIComponent("Dernière_mensualité_ajustée_avec_assurance") + "=" + encodeURIComponent($result.querySelector(".insurance-credit-last-monthly").textContent + " €")
         + "&" + encodeURIComponent("Coût_total_crédit_hors_assurance") + "=" + encodeURIComponent($result.querySelector(".credit-total-cost").textContent + " €")
         + "&" + encodeURIComponent("Coût_total_assurance") + "=" + encodeURIComponent($result.querySelector(".insurance-total-cost").textContent + " €")
         + "&" + encodeURIComponent("Frais_dossier") + "=" + encodeURIComponent($result.querySelector(".setup-fees").textContent + " €")
         + "&" + encodeURIComponent("Assurance_emprunteur") + "=" + encodeURIComponent($insurance.checked ? "Oui" : "Non");

      if (current_actioncom_discount && current_actioncom_discount.isValid && current_actioncom_discount.isAppliable) {
         url += "&" + encodeURIComponent("Code_promo") + "=" + encodeURIComponent(discount_code);

         if (current_actioncom_discount.label && current_actioncom_discount.label.length > 0) {
            url += "&" + encodeURIComponent("Promo") + "=" + encodeURIComponent(current_actioncom_discount.label);
         }
         if (current_actioncom_discount.labelShort && current_actioncom_discount.labelShort.length > 0) {
            url += "&" + encodeURIComponent("Libellé_promo") + "=" + encodeURIComponent(current_actioncom_discount.labelShort);
         }
         if (current_actioncom_discount.mentionsShort && current_actioncom_discount.mentionsShort.length > 0) {
            url += "&" + encodeURIComponent("Mentions") + "=" + encodeURIComponent(current_actioncom_discount.mentionsShort);
         }
      }

      if ($incomes.value.length > 0) {
         url += "&" + encodeURIComponent("Revenu_mensuel") + "=" + encodeURIComponent($incomes.value + " €");
      }
      if ($charges.value.length > 0) {
         url += "&" + encodeURIComponent("Charges_mensuelles") + "=" + encodeURIComponent($charges.value + " €");
      }

      // 270387 => demander un financement
      // 270388 => utiliser mon crédit renouvelable
      // if (offer_type !== "classic" && current_actioncom_discount && current_actioncom_discount.isValid && current_actioncom_discount.isAppliable) { // @TODO: improve condition
      if (offer_type !== "classic") {
         // id GED for messagerie "crédit conso" > "utiliser mon crédit renouvelable"
         url += "&idGed=270388";
         console.log("crédit conso > utiliser mon crédit renouvelable");
      } else {
         // id GED for messagerie "crédit conso" > "demande de financement"
         url += "&idGed=270387";
         console.log("crédit conso > demande de financement");
      }

      let additionalParameters = "";
      if (parameters["utm_source"] && parameters["utm_source"] === 'gmb') {
         additionalParameters += "&" + window.location.search.slice(1, window.location.search.length);
      }*/
 
      // Temporary replacement code
      if (offer_type !== "classic") {
         // id GED for messagerie "crédit conso" > "utiliser mon crédit renouvelable"
         url += "?idGed=270388";
         console.log("crédit conso > utiliser mon crédit renouvelable");
      } else {
         // id GED for messagerie "crédit conso" > "demande de financement"
         url += "?idGed=270387";
         console.log("crédit conso > demande de financement");
      }

      console.log(url);
      // https://mon-ab.hml.bad.arkea.com/messagerie/ecriremessage?simulateur=creditrenouvelable&Montant_pr%C3%AAt=5%C2%A0000%20%E2%82%AC&Dur%C3%A9e=2%20ans&Mensualit%C3%A9_hors_assurance=227%2C74%20%E2%82%AC&Derni%C3%A8re_mensualit%C3%A9_ajust%C3%A9e_hors_assurance=53%20%E2%82%AC&TAEG=8%2C90%20%25&TAEA=0%2C37%20%25&Taux_d%C3%A9biteur=8%2C56%20%25&Montant_d%C3%BB=5%C2%A0718%2C48%20%E2%82%AC&Co%C3%BBt_mensuel_assurance=10%2C53%20%E2%82%AC&Mensualit%C3%A9_avec_assurance=238%2C27%20%E2%82%AC&23_mensualit%C3%A9s_de=238%2C27%20%E2%82%AC&Derni%C3%A8re_mensualit%C3%A9_ajust%C3%A9e_avec_assurance=54%20%E2%82%AC&Co%C3%BBt_total_cr%C3%A9dit_hors_assurance=5%C2%A0456%2C4%20%E2%82%AC&Co%C3%BBt_total_assurance=252%2C72%20%E2%82%AC&Frais_dossier=0%2C00%20%E2%82%AC&Code_promo=LPC2023&Promo=OFFRE%20Le%20Printemps%20du%20Cr%C3%A9dit%2C%20sous%20conditions&Libell%C3%A9_promo=OFFRE%20Le%20Printemps%20du%20Cr%C3%A9dit&Mentions=UN%20CREDIT%20VOUS%20ENGAGE%20ET%20DOIT%20ETRE%20REMBOURSE.%20VERIFIEZ%20VOS%20CAPACITES%20DE%20REMBOURSEMENT%20AVANT%20DE%20VOUS%20ENGAGER.%0A%0AOffres%20de%20financement%20propos%C3%A9es%20par%20AXA%26nbsp%3BBanque%2C%20disponibles%20aupr%C3%A8s%20des%20interlocuteurs%20AXA%20d%C3%BBment%20habilit%C3%A9s%2C%20interm%C3%A9diaires%20en%20op%C3%A9rations%20de%20banque%20pour%20le%20compte%20d%27AXA%26nbsp%3BBanque%2C%20sous%20r%C3%A9serve%20d%27acceptation%20par%20AXA%26nbsp%3BBanque%26nbsp%3BFinancement%2C%20le%20pr%C3%AAteur.%20Vous%20disposez%20d%27un%20d%C3%A9lai%20l%C3%A9gal%20de%20r%C3%A9tractation.%20Aucun%20versement%2C%20de%20quelque%20nature%20que%20ce%20soit%2C%20ne%20peut%20%C3%AAtre%20exig%C3%A9%20d%27un%20particulier%2C%20avant%20l%27obtention%20d%27un%20ou%20plusieurs%20pr%C3%AAts%20d%27argent.%0A%0A(*)%20Simulation%20%C3%A0%20valeur%20informative%20et%20non%20contractuelle%2C%20r%C3%A9alis%C3%A9e%20sur%20la%20base%20des%20conditions%20tarifaires%20actuellement%20en%20vigueur%20au%20et%20sous%20r%C3%A9serve%20d%27%C3%AAtre%20client%20de%20plus%20de%206%20mois%20chez%20AXA%20et%20de%20pr%C3%A9lever%20les%20%C3%A9ch%C3%A9ances%20du%20pr%C3%AAt%20sur%20un%20compte%20de%20d%C3%A9p%C3%B4t%20AXA%20Banque%20%C3%A9quip%C3%A9%20d%27une%20carte%20bancaire.%20Pour%20plus%20d%27informations%2C%20n%27h%C3%A9sitez%20pas%20%C3%A0%20contacter%20nos%20conseillers.&idGed=270388
      window.location.href = url;

      // https://mon-ab.hml.bad.arkea.com/messagerie/ecriremessage?simulateur=pretperso&Projet=Travaux&Montant_pr%C3%AAt=56%C2%A0789%20%E2%82%AC&Dur%C3%A9e=3%C2%A0ans&Mensualit%C3%A9_hors_assurance=1%C2%A0676%2C05%20%E2%82%AC&TAEG=4%2C05%20%25&TAEA=1%2C63%20%25&Taux_d%C3%A9biteur=3%2C98%20%25&Montant_d%C3%BB=60%C2%A0337%2C78%20%E2%82%AC&Co%C3%BBt_mensuel_assurance=39%2C75%20%E2%82%AC&Mensualit%C3%A9_avec_assurance=1%C2%A0715%2C80%20%E2%82%AC&Co%C3%BBt_total_cr%C3%A9dit_hors_assurance=3%C2%A0548%2C78%20%E2%82%AC&Co%C3%BBt_total_assurance=1%C2%A0431%2C08%20%E2%82%AC&Frais_dossier=0%2C00%20%E2%82%AC&Assurance_emprunteur=Non&Code_promo=GREEN21&Promo=OFFRE%20%C3%89CO-PR%C3%8AT%2C%20sous%20conditions&Libell%C3%A9_promo=OFFRE%20%C3%89CO-PR%C3%8AT&Mentions=UN%20CREDIT%20VOUS%20ENGAGE%20ET%20DOIT%20ETRE%20REMBOURSE.%20VERIFIEZ%20VOS%20CAPACITES%20DE%20REMBOURSEMENT%20AVANT%20DE%20VOUS%20ENGAGER.%0A%0AOffres%20de%20financement%20propos%C3%A9es%20par%20AXA%26nbsp%3BBanque%2C%20disponibles%20aupr%C3%A8s%20des%20interlocuteurs%20AXA%20d%C3%BBment%20habilit%C3%A9s%2C%20interm%C3%A9diaires%20en%20op%C3%A9rations%20de%20banque%20pour%20le%20compte%20d%27AXA%26nbsp%3BBanque%2C%20sous%20r%C3%A9serve%20d%27acceptation%20par%20AXA%26nbsp%3BBanque%26nbsp%3BFinancement%2C%20le%20pr%C3%AAteur.%20Vous%20disposez%20d%27un%20d%C3%A9lai%20l%C3%A9gal%20de%20r%C3%A9tractation.%20Aucun%20versement%2C%20de%20quelque%20nature%20que%20ce%20soit%2C%20ne%20peut%20%C3%AAtre%20exig%C3%A9%20d%27un%20particulier%2C%20avant%20l%27obtention%20d%27un%20ou%20plusieurs%20pr%C3%AAts%20d%27argent.%0A%0A(*)%20Simulation%20%C3%A0%20valeur%20informative%20et%20non%20contractuelle%2C%20r%C3%A9alis%C3%A9e%20sur%20la%20base%20des%20conditions%20tarifaires%20actuellement%20en%20vigueur%20au%20et%20sous%20r%C3%A9serve%20d%27%C3%AAtre%20client%20de%20plus%20de%206%20mois%20chez%20AXA%20et%20de%20pr%C3%A9lever%20les%20%C3%A9ch%C3%A9ances%20du%20pr%C3%AAt%20sur%20un%20compte%20de%20d%C3%A9p%C3%B4t%20AXA%20Banque%20%C3%A9quip%C3%A9%20d%27une%20carte%20bancaire.%20Pour%20plus%20d%27informations%2C%20n%27h%C3%A9sitez%20pas%20%C3%A0%20contacter%20nos%20conseillers.&Revenus=sur%2012%20mois%2C%2081%20468%20%E2%82%AC&Charges=678%20%E2%82%AC&idGed=270387
  }

   /* Single CTA */
  let handleSingleCTA = function (e, redirectURL = null, additionalParameters = null) {
      if (parameters["utm_content"] &&
        (
           [
              'lpc24_assures_lancement',
              'lpc24_assures_relance',
              'lpc24_assures_prolongation',
              'lpc24_inter_lancement',
              'lpc24_inter_relance',
              'lpc24_inter_prolongation',
              'ic_2025_inter_lancement',
              'ic_2025_inter_relance',
              'ic_2025_assu_lancement',
              'ic_2025_assu_qlqs_jours',
              'ic_2025_inter_lancement',
              'ic_2025_inter_qlqs_jours',
           ].indexOf(parameters["utm_content"]) !== -1
           || parameters["utm_content"].indexOf("assures") !== -1
        )
      ) {
         devisCTA(e, redirectURL, additionalParameters);
      } else {
         messagerieCTA(e, redirectURL);
      }
  }

  if ($singleCTA) {
   $singleCTA.onclick = handleSingleCTA;
  }
  if ($customerMobileCTA) {
   $customerMobileCTA.onclick = messagerieCTA;
  }
  if ($desktopCustomerCTA) {
   $desktopCustomerCTA.onclick = messagerieCTA;
  }

})();

(function () {

  /* Accordion FAQ */
  function initFaq(toggle) {
   const button = document.createElement('button');
   button.innerText = '-';
   toggle.append(button);
  }
  function setFaqExpanded(toggle, expanded) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      const button = toggle.querySelector('button');
      if (button) {
         button.innerHTML = expanded ? '<span class="desktop">−</span><span class="mobile"><i class="axa-icons axa-icons-arrow-up"></i></span>' : '<span class="desktop">+</span><span class="mobile"><i class="axa-icons axa-icons-arrow-down"></i></span>';
      }
      var questionBlock = toggle.closest('.faq-item');
      if (questionBlock) {
         questionBlock.classList.toggle('is-collapsed', !expanded);
      }
   }

   const faqToggles = document.querySelectorAll('#faq .faq-item__question');
   for (var i = 0; i < faqToggles.length; i++) {
      (function (toggle) {
         initFaq(toggle);
         setFaqExpanded(toggle, false);
         toggle.addEventListener('click', function () {
            const expanded = toggle.getAttribute('aria-expanded') === 'true';
            setFaqExpanded(toggle, !expanded);
         });
      })(faqToggles[i]);
   }

})();

